export default "skymp5-front/07863f7f6cd3e41d2d4dd98555709017.svg";